import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common.service';
import { CaseManagementService } from '../services/caseManagement.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-summary2',
  templateUrl: './company-summary2.component.html',
  styleUrls: ['./company-summary2.component.css']
})
export class CompanySummary2Component implements OnInit {

  constructor(private commonService: CommonService,
    private caseManagementService: CaseManagementService,
    private router: Router) { }

  ngOnInit() {
    this.commonService.checkLoggedInUser();
  }

  showTermsAndConditions() {
    this.caseManagementService.setIsFromVerificationLink('');
    this.router.navigate([`/termsAndConditions`]);
  }

}
